import { render } from "./MFA.vue?vue&type=template&id=581912f2&lang=pug"
import script from "./MFA.vue?vue&type=script&lang=js"
export * from "./MFA.vue?vue&type=script&lang=js"

import "./MFA.vue?vue&type=style&index=0&id=581912f2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__